module.exports = __webpack_public_path__ + "static/media/vehicleMarkerCallout_Nay.0aa7bd32.svg";